const trim = (url) => (url || '').replace(/\/$/, '');

export const API = {
  login:
    trim(process.env.REACT_APP_LOGIN_URL) ||
    'https://sourceiq-login-dha8dahravh6eyet.eastus-01.azurewebsites.net',
  supplierMgmt:
    trim(process.env.REACT_APP_SUPPLIER_MGMT_URL) ||
    'https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net',
  engagement:
    trim(process.env.REACT_APP_ENGAGEMENT_SERVICE_URL) || 'http://localhost:3007',
  rfp:
    trim(process.env.REACT_APP_RFP_URL) ||
    'https://rfpprocessing-bmb0avdsdfemchb5.centralus-01.azurewebsites.net',
  chat:
    trim(process.env.REACT_APP_CHAT_URL) ||
    'https://sourceiq-collab-a3f2exdpbudtdnf4.eastus-01.azurewebsites.net',
};

export const MANAGEMENT_API_KEY =
  process.env.REACT_APP_MANAGEMENT_SUPPLIER_API_KEY || '';

export const loginApi = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API.login}/api${p}`;
};

export const supplierApi = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API.supplierMgmt}/api${p}`;
};

export const engagementAnalyticsApi = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API.engagement}/api/v1/analytics/engagement${p}`;
};

export const dashboardApi = (path = '') =>
  `${API.supplierMgmt}/api/api/dashboard/${path.replace(/^\//, '')}`;

export const rfpApi = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API.rfp}/api/v1${p}`;
};

export const chatApi = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API.chat}/chat${p}`;
};

export function getAuthHeaders(getState, { includeApiKey = false } = {}) {
  const token = getState?.()?.auth?.token;
  if (!token) throw new Error('Authentication token not found');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  if (includeApiKey && MANAGEMENT_API_KEY) {
    headers['x-api-key'] = MANAGEMENT_API_KEY;
  }
  return headers;
}

export function getOptionalAuthHeaders(getState, { includeApiKey = false } = {}) {
  const token = getState?.()?.auth?.token;
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (includeApiKey && MANAGEMENT_API_KEY) {
    headers['x-api-key'] = MANAGEMENT_API_KEY;
  }
  return headers;
}
